import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  get_partyIdAdapter2v7zx778kk10s as get_partyIdAdapter,
  get_playerIdAdapter2h87xjwribaa as get_playerIdAdapter,
} from '../../../adapter/Adapter.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { DeletePlayerInput3nqh5he11jo1p as DeletePlayerInput } from '../DeletePlayerInput.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DeletePlayerInput_InputAdapterClass;
function DeletePlayerInput_InputAdapter() {
  if (DeletePlayerInput_InputAdapterClass === VOID) {
    class $ {
      e40(reader, customScalarAdapters) {
        throw IllegalStateException().o('Input type used in output position');
      }
      g6r(writer, customScalarAdapters, value) {
        writer.h48('partyId');
        get_partyIdAdapter().f40(writer, customScalarAdapters, value.o6o_1);
        writer.h48('playerId');
        get_playerIdAdapter().f40(writer, customScalarAdapters, value.p6o_1);
      }
      f40(writer, customScalarAdapters, value) {
        return this.g6r(writer, customScalarAdapters, value instanceof DeletePlayerInput() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'DeletePlayerInput_InputAdapter', VOID, VOID, [Adapter()]);
    DeletePlayerInput_InputAdapterClass = $;
  }
  return DeletePlayerInput_InputAdapterClass;
}
var DeletePlayerInput_InputAdapter_instance;
function DeletePlayerInput_InputAdapter_getInstance() {
  return DeletePlayerInput_InputAdapter_instance;
}
//region block: init
DeletePlayerInput_InputAdapter_instance = new (DeletePlayerInput_InputAdapter())();
//endregion
//region block: exports
export {
  DeletePlayerInput_InputAdapter_instance as DeletePlayerInput_InputAdapter_instance1cxdu15t78vv8,
};
//endregion

//# sourceMappingURL=DeletePlayerInput_InputAdapter.mjs.map
